import { createUseStyles } from 'react-jss';
export const useTextClasses = createUseStyles({
    text(props) {
        const rules = props.variant ? { ...props.theme.typography.variants[props.variant] } : {};
        rules.fontFamily = props.theme.typography.fontFamily;
        if (props.fontSize) {
            rules.fontSize = typeof props.fontSize === 'string' ? props.fontSize : `${props.fontSize}rem`;
        }
        if (props.fontWeight) {
            rules.fontWeight = props.fontWeight;
        }
        if (props.letterSpacing) {
            rules.letterSpacing = props.letterSpacing;
        }
        if (props.lineHeight) {
            rules.lineHeight = typeof props.lineHeight === 'string' ? props.lineHeight : `${props.lineHeight}rem`;
        }
        if (props.isTruncated) {
            rules.overflow = 'hidden';
            rules.textOverflow = 'ellipsis';
            if (typeof props.isTruncated === 'number') {
                rules.lineClamp = props.isTruncated;
                rules.display = '-webkit-box';
                rules['-webkit-box-orient'] = 'vertical';
                rules.whiteSpace = 'normal';
            }
            else {
                rules.whiteSpace = 'nowrap';
            }
        }
        if (props.align) {
            rules.textAlign = props.align;
        }
        if (props.textTransform) {
            rules.textTransform = props.textTransform;
        }
        if (props.wordBreak) {
            rules.wordBreak = props.wordBreak;
        }
        if (props.textDecoration) {
            rules.textDecoration = props.textDecoration;
        }
        if (props.whiteSpace) {
            rules.whiteSpace = props.whiteSpace;
        }
        return rules;
    },
});
